module.exports = __webpack_public_path__ + "static/media/app-pedido.adcc25f9.png";